import { render, staticRenderFns } from "./DashboardInformation.vue?vue&type=template&id=74008624"
import script from "./DashboardInformation.vue?vue&type=script&lang=js"
export * from "./DashboardInformation.vue?vue&type=script&lang=js"
import style0 from "./DashboardInformation.vue?vue&type=style&index=0&id=74008624&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports